export default "//cdn.scentbird.com/assets/frontbird-site/images/handCare_e1093b.png";